import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { destroy } from 'redux-form';

import './components/LandlordPropertiesPage.css';
import 'react-table/react-table.css';

import PropertiesNonGrid from './components/PropertiesNonGrid';

import FlatButton from 'material-ui/FlatButton';

import { getProperties } from 'actions/landlordPropertiesActions';
import { AccentColor } from 'helpers/AccentColorHelper';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';
import { getTranslatedString } from 'helpers/i18n';

export default connect(
  store => {
    return {
      showPage: store.authentication.showPage,
      properties: store.landlordProperties.properties,
    };
  },
  { getProperties, destroy }
)(
  class LandlordProperties extends Component {
    UNSAFE_componentWillMount = () => {
      this.props.getProperties();
      this.props.destroy('add_property');
    };

    render() {
      return (
        <div className="body" role="main">
          {this.props.showPage && (
            <div className="centers">
              <div>
                <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
                  <span className="page-title">
                    {getTranslatedString('landlordPortal.properties.properties')}
                  </span>
                  <RenderIfToggleOn toggle="ui.properties_page.add_property">
                    <FlatButton
                      label={getTranslatedString('landlordPortal.properties.addProperty')}
                      type="submit"
                      primary={true}
                      backgroundColor={AccentColor()}
                      hoverColor="grey"
                      onClick={() => {
                        // ensure that add_property form is cleared before loading
                        this.props.destroy('add_property');
                        browserHistory.push('/companies/add_property');
                      }}
                      style={{
                        color: 'white',
                        float: 'right',
                        height: '30px',
                        fontSize: '13px',
                        lineHeight: '30px',
                        marginTop: '3px',
                      }}
                    />
                  </RenderIfToggleOn>
                </div>
                <div className="dashboard-container" ref="propertiesContainer">
                  <div className="row">
                    <PropertiesNonGrid />
                  </div>
                </div>
                <div style={{ height: '100px' }} />
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);
